import React, { RefObject } from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EconomicImpact from "../../../../components/Icons/EconomicImpact";
import theme from "../../../../components/styles/theme/theme";
import { CURRENCY, isRegion } from "../../../../config";

type Props = {
  gdpContributionRef: RefObject<HTMLHeadingElement>;
  taxRevenueContributionRef: RefObject<HTMLHeadingElement>;
  valueAddedToTheLocalEconomyRef: RefObject<HTMLHeadingElement>;
  valueAddedRef: RefObject<HTMLHeadingElement>;
};

export const EconomicImpactBox: React.FC<Props> = ({
  gdpContributionRef,
  taxRevenueContributionRef,
  valueAddedToTheLocalEconomyRef,
  valueAddedRef,
}: Props) => {
  const { t } = useTranslation();

  const valueAddedPerCurrency = t("boxes.value_added_per_currency", {
    currency: CURRENCY,
  });

  return (
    <div className="economic_impact">
      <div className="economic_title">
        <Typography
          sx={{
            fontWeight: "600",
          }}
        >
          {t("boxes.economic_impact")}
          <EconomicImpact
            color={theme.palette.secondary.main}
            height="13px"
            width="18px"
            style={{ width: '25px'}}
          />
        </Typography>
      </div>
      <div className="value_added">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={valueAddedToTheLocalEconomyRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {t("boxes.value_added_local_economy")}
        </Typography>
      </div>
      <div className="gdp_contribution">
        <Typography
          variant="h4"
          component="h4"
          color={theme.palette.secondary["600"]}
          ref={gdpContributionRef}
        >
          0
        </Typography>
        <Typography variant="body2" component="p">
          {isRegion.usa ? t("boxes.gdp_supported") : t("boxes.gdp_contribution")}
        </Typography>
      </div>
      {!isRegion.usa && (
        <div className="tax_revenue">
          <Typography
            variant="h4"
            component="h4"
            color={theme.palette.secondary["600"]}
            ref={taxRevenueContributionRef}
          >
            0
          </Typography>
          <Typography variant="body2" component="p">
            {t("boxes.tax_revenue_contribution")}
          </Typography>
        </div>
      )}
      {!isRegion.usa && (
        <div className="value_added_per">
          <Typography
            variant="h4"
            component="h4"
            color={theme.palette.secondary["600"]}
            ref={valueAddedRef}
          >
            0
          </Typography>
          <Typography variant="body2" component="p">
            {valueAddedPerCurrency}
          </Typography>
        </div>
      )}
    </div>
  );
};
